'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  require('./animations.css');
  require('./colors.css');
  require('./layout.css');
  require('./opacities.css');
  require('./sizing.css');
  require('./theme-day.css');
  require('./theme-night.css');
  require('./typography.css');
};